import { useDispatch, useSelector } from "react-redux";
import { memo, useEffect, useRef, useState } from "react";
import { ApiContainer } from "../../utils/api";
import { toggleModelShow } from "../../shared/CustomFunc";

const editAbleEmailContainer = () => {
  const containerRef = useRef(null);
  const { api } = ApiContainer();
  const createdDepartmentDetail = useSelector(
    (state) => state?.api?.createdDepartmentDetail
  );
  const getEmailLoader = useSelector((state) => state?.api?.loader?.getEmail);
  const submitEmailLoader = useSelector(
    (state) => state?.api?.loader?.submitEmail
  );
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    if (createdDepartmentDetail) {
      const getEmailTemplate = async () => {
        const email = await api({
          endPoint: `organization/${createdDepartmentDetail?.organization_original_id}/locations/${createdDepartmentDetail?.location_original_id}/departments/${createdDepartmentDetail?.department_original_id}/welcome-email`,
          method: "GET",
          urlencoded: false,
          parent: "getEmail",
          needLoader: true,
        });
        if (email?.status) setEmail(email?.data);
      };
      getEmailTemplate();
    }
  }, [createdDepartmentDetail]);

  const getContainerData = async () => {
    const response = await api({
      endPoint: `organization/${createdDepartmentDetail?.organization_original_id}/locations/${createdDepartmentDetail?.location_original_id}/departments/${createdDepartmentDetail?.department_original_id}/welcome-email`,
      method: "PUT",
      data: containerRef?.current?.innerHTML,
      urlencoded: false,
      parent: "submitEmail",
      needLoader: true,
      showToastMessage: true,
      header: {
        "Content-Type": "text/html",
      },
    });
    if (response?.status)
      dispatch(toggleModelShow("editDepartmentEmailTemplate"));
  };
  return {
    containerRef,
    getContainerData,
    email,
    getEmailLoader,
    submitEmailLoader,
  };
};

export default editAbleEmailContainer;
